import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import LandingPageHeader from "../components/LandingPageHeader";
import LandingPageFooter from "../components/LandingPageFooter";

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

function PaymentSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const transactionId = searchParams.get('transactionId');
    const amount = searchParams.get('amount');

    if (transactionId) {
      axios.get(`${API_URL}/check-transaction-status/${transactionId}`)
        .then(response => {
          setTransactionDetails({
            transactionId,
            amount,
            status: response.data.status
          });
        })
        .catch(error => {
          console.error('Error fetching transaction details:', error);
          navigate('/failure');
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      navigate('/pre-book');
    }
  }, [location.search, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col bg-gradient-to-br from-green-100 to-green-300">
        <LandingPageHeader />
        <main className="flex-grow flex items-center justify-center">
          <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-green-500"></div>
        </main>
        <LandingPageFooter />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-green-100 to-green-300">
      <LandingPageHeader />
      <main className="flex-grow flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-8">
          <div className="text-center">
            <div className="mx-auto mb-4">
              <svg className="w-16 h-16 text-green-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Payment Successful!</h2>
            <p className="text-gray-600 mb-8">Thank you for your payment. Your transaction has been completed successfully.</p>
            
            <div className="space-y-4 text-left bg-gray-50 p-4 rounded-lg mb-8">
              <p><strong>Transaction ID:</strong> {transactionDetails?.transactionId}</p>
              <p><strong>Amount Paid:</strong> ₹{transactionDetails?.amount}</p>
            </div>

            <button
              onClick={() => navigate('/pre-book')}
              className="w-full bg-purple-600 text-white rounded-md py-3 px-4 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-400 focus:ring-opacity-75 transition-colors"
            >
              Return to Home
            </button>
          </div>
        </div>
      </main>
      <LandingPageFooter />
    </div>
  );
}

export default PaymentSuccess;